import React from "react";
import { PrismicRichText } from "@prismicio/react";

const SECTION_HEADING_CLASS =
    "text-2xl md:text-[32px] font-normal capitalize font-libre text-Heading_Black text-center";

const SectionHeading = ({ text, simpleText }) => {
    return simpleText ? (
        <h1 className={SECTION_HEADING_CLASS}>{simpleText}</h1>
    ) : (
        <PrismicRichText
            field={text}
            components={{
                heading1: ({ children }) => (
                    <h1 className={SECTION_HEADING_CLASS}>{children}</h1>
                ),
                paragraph: ({ children }) => (
                    <h1 className={SECTION_HEADING_CLASS}>{children}</h1>
                ),
            }}
        ></PrismicRichText>
    );
};

export default SectionHeading;
